import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MapAddress } from '@/types/address';

type State = {
  address: MapAddress | null;
};

type Actions = {
  setCurrentLocation: (address: MapAddress) => void;
};

export const useLocationStore = create<State & Actions>()(
  persist(
    (set) => ({
      address: null,

      setCurrentLocation: (address: MapAddress) => {
        set({ address: address });
      },
    }),
    { name: 'place_name' }
  )
);
